exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".beauti-contextmenu-ul{padding:4px 0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-sizing:border-box;box-sizing:border-box}.beauti-contextmenu-ul .beauti-contextmenu-submenu{padding:6px 8px 6px 10px;cursor:pointer}.beauti-contextmenu-ul .beauti-contextmenu-submenu:hover{background-color:#f2f2f2}.beauti-contextmenu-ul li.beauti-contextmenu-item{min-width:100px;padding:6px 8px 6px 10px;cursor:pointer}.beauti-contextmenu-ul li.beauti-contextmenu-item .beauti-contextmenu-submenu{padding:0}", ""]);

// exports
